module.exports = __webpack_public_path__ + "static/media/my_family_doctor_slider_phone1.919bf6cf.png";